import { render, staticRenderFns } from "./GroupAssignmentComponent.vue?vue&type=template&id=1a02ac6c"
import script from "./GroupAssignmentComponent.vue?vue&type=script&lang=js"
export * from "./GroupAssignmentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports